// Job status values the server can store. Production jobs.status is
// NOT NULL enum('in_process','completed','priority') DEFAULT 'priority'
// (models/job.js). The iPad app (JobWebForm.swift) uses the same list.
export const JOB_STATUS_OPTIONS = [
  { name: "Priority", value: "priority" },
  { name: "In Process", value: "in_process" },
  { name: "Completed", value: "completed" },
];
export const JOB_STATUS_DEFAULT = "priority";
